import React from 'react';

type Props = {
  children?: React.ReactNode;
};

const WpDrawerV2Body = ({ children }: Props) => {
  const baseClassName = 'WpDrawerV2';

  return <div className={`${baseClassName}__content__body`}>{children}</div>;
};

export default WpDrawerV2Body;
